import moment from 'moment'
import { dateToMysql } from '@/helpers/dates'

const prepareShow = profile => {
  if (profile.birthdate !== null) {
    profile.birthdate = moment(profile.birthdate, 'YYYYMMDD').format('DD/MM/YYYY')
  } else {
    delete profile.birthdate
  }
  return profile
}
const prepareSave = profile => {
  profile.country_register = profile.country_register.replace('-', '')
  if (profile.birthdate !== null) {
    profile.birthdate = dateToMysql(profile.birthdate)
  } else {
    delete profile.birthdate
  }

  delete profile.email

  return profile
}

export default {
  doLoad () {
    this.$resource.get('me')
      .then((data) => {
        this.profile = prepareShow({...data})
      })
  },
  doSave () {
    const profile = prepareSave({...this.profile})
    this.$resource.update('me', profile)
      .then(({data}) => {
        this.$toast.success('Perfil alterado com sucesso.')
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  /** ativando ou nao sms notificacoes */
  sendSMS: function (event) {
    if (event.target.checked) {
      this.profile.sms = event.target.checked
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/account-settings/resources/methods.js